import React from "react";
import { Icon } from "@iconify/react";

const UpgradeIcon = () => (
  <Icon icon="lucide:trending-up" width={18} height={18} />
);

export default UpgradeIcon;
